import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { CampaignInstructionBanner } from "./campaign-instruction-banner";
import { CampaignSubmissionBanners } from "./campaign-submission-banners";

interface CampaignAcknowledgePanelProps {
  onBehalfOfLogin?: string;
  respondByDate?: string;
  isSubmitting: boolean;
  submitError: Error | null;
  hasSubmitSucceeded: boolean;
  saveAttemptCount: number;
  onAcknowledge: () => void;
}

export const CampaignAcknowledgePanel: FC<CampaignAcknowledgePanelProps> = ({
  onBehalfOfLogin,
  respondByDate,
  isSubmitting,
  submitError,
  hasSubmitSucceeded,
  saveAttemptCount,
  onAcknowledge,
}) => (
  <Col gridGap="S300">
    <CampaignInstructionBanner
      message={getString(
        onBehalfOfLogin ? "campaigns.noAssetsMessageOnBehalf" : "campaigns.noAssetsMessage"
      )}
      onBehalfOfLogin={onBehalfOfLogin}
      respondByDate={respondByDate}
    />

    <CampaignSubmissionBanners
      hasSubmitSucceeded={hasSubmitSucceeded}
      submitError={submitError}
      saveAttemptCount={saveAttemptCount}
    />

    <Row justifyContent="flex-end">
      <Button
        variant={ButtonVariant.Primary}
        disabled={isSubmitting}
        onClick={onAcknowledge}
        dataTestId="acknowledge-campaign-button"
      >
        {isSubmitting ? getString("campaigns.saving") : getString("campaigns.acknowledge")}
      </Button>
    </Row>
  </Col>
);
